import dayjs from "dayjs";
import { defaultDateFormat } from "./common";

export const setDateTime = (dateTime, format = null) => {
  return dayjs(dateTime).format(format ?? defaultDateFormat);
};
